const search = require('./search');
/* eslint-disable */
function init() {
    // Header Scrolled
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 0) {
            $('#boggiHeader').addClass('scrolled');
        } else {
            // Remove the 'scrolled' class from the header
            $('#boggiHeader').removeClass('scrolled');
        }
    });
    // Opening Navbar
    $('.navbar-toggler-button').on('click', function () {
        $('.navbar-brand').addClass('open');
        $('.navbar-items').addClass('open');
        $('.order__cols').css('display', 'none');
        $('.icon--bag').css('z-index', '-1');
        $('.minicart__trigger').css('z-index', '-1');
        $('body').css('overflow', 'hidden');
        $('html').css('overflow', 'hidden');
    });

    // Opening Navbar Item
    $('.navbar-item > a.non-clickable').on('click', function (e) {
        if ($(window).width() < 992) {
            e.preventDefault();
            // Setting the selected title instead of navbrand
            $('.navbar-selected-title').text(this.innerText).addClass('bt-d-block').removeClass('bt-d-none');
            $('.navbar-brand').addClass('bt-d-none').removeClass('bt-d-block');
            var menu = $(this).next('.menu-container');
            if (menu.hasClass('hide')) {
                menu.addClass('bt-d-flex'); // Show as flex
                $('.navbar-items').css('overflow', 'hidden');
            } else {
                menu.addClass('hide'); // Hide
                $('.navbar-items').css('overflow', 'auto');
            }
            // Optionally, close other open menus (if needed)
            $('.menu-container').not(menu).addClass('bt-d-none');
        }
        
    });

    // Back to the Main Menu
    $('.navbar-slide-out-render').on('click', function () {
        $('.menu-container').addClass('hide').removeClass('bt-d-flex');
        $('.navbar-items').css('overflow', 'auto');
        // Setting navbrand to default and removing the title
        $('.navbar-selected-title').addClass('bt-d-none').removeClass('bt-d-block');
        $('.navbar-brand').addClass('bt-d-block').removeClass('bt-d-none');
    });
    // Closing NavBar
    $('#navbar-trigger-close').on('click', function () {
        $('.navbar-brand').removeClass('open');
        $('.navbar-items').removeClass('open');
        $('.menu-container').addClass('hide').removeClass('bt-d-flex');
        $('.navbar-selected-title').addClass('bt-d-none').removeClass('bt-d-block');
        $('.navbar-brand').addClass('bt-d-block').removeClass('bt-d-none');;
        $('.order__cols').css('display', 'block');
        $('.icon--bag').css('z-index', '0');
        $('.minicart__trigger').css('z-index', '5');
        $('body').css('overflow', 'auto');
        $('html').css('overflow', 'auto');
        $('.navbar-items').css('overflow', 'auto');
    });

    $('#m-wishlist-show, #l-wishlist-show').click(function (event) {
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation_wishlist_click',
            'eventLabel': 'top navigation wishlist click',
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    });

    $('.level-1-category').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        var level1Cat=$(this).text().trim();
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation',
            'eventLabel': level1Cat,
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    });

    $('.level-2-category').on('click', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        var level1Cat=$(this).closest('.navbar-item').find('.level-1-category').text().trim();
        var level2Cat=$(this).text().trim();
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation',
            'eventLabel': level1Cat +' > '+level2Cat,
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    });

    $(document).on('click', '.l-cart-show, #m-cart-show', function (e) {
        var user = dataLayer.find(o => o.user != null).user;
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'top_navigation',
            'eventAction': 'top_navigation_bag_click',
            'eventLabel': 'top navigation bag click',
            'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
            'screenName': 'Top navigation',
            'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
            'userId': user.user_id != '' ? user.user_id : ''
        });
    });

    if($('#boggiHeader').length) {
        search.init();
    }
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./cartridges/app_boggi_core/cartridge/js/sections/header/header.js